import { useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageSquarePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { http, errMsg } from "@/lib/api";
import { useAuth } from "@/context/Auth";

export const FeedbackButton = () => {
  const { user } = useAuth();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [contact, setContact] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      await http.post("/site-feedback", { text, contact, page: loc.pathname });
      toast.success("Thanks — feedback sent!");
      setText("");
      setContact("");
      setOpen(false);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="feedback-open-button" className="btn-ghost h-9 px-3 rounded-full text-sm flex items-center gap-1.5">
          <MessageSquarePlus size={14} /> <span className="hidden md:inline">Feedback</span>
        </button>
      </DialogTrigger>
      <DialogContent data-testid="feedback-dialog" style={{ background: "var(--surface)" }}>
        <DialogTitle className="font-display text-xl">Feedback &amp; suggestions</DialogTitle>
        <DialogDescription style={{ color: "var(--ink-3)" }}>This app is in beta. Bugs, wrong answers, ideas — all welcome.</DialogDescription>
        <textarea data-testid="feedback-text-input" value={text} onChange={(e) => setText(e.target.value)} rows={5} maxLength={3000} placeholder="What could be better?"
          className="w-full rounded-lg p-3 text-sm outline-none focus:ring-2 focus:ring-[var(--accent)]" style={{ background: "var(--muted-bg)", border: "1px solid var(--line)", color: "var(--ink)" }} />
        {!user && (
          <input data-testid="feedback-contact-input" value={contact} onChange={(e) => setContact(e.target.value)} maxLength={200} placeholder="Email for a reply (optional)"
            className="w-full h-10 rounded-lg px-3 text-sm outline-none focus:ring-2 focus:ring-[var(--accent)]" style={{ background: "var(--muted-bg)", border: "1px solid var(--line)", color: "var(--ink)" }} />
        )}
        <div className="flex">
          <button data-testid="feedback-submit-button" onClick={send} disabled={busy || text.trim().length < 3} className="btn-primary flex-1 h-11 rounded-full font-semibold flex items-center justify-center gap-2">
            {busy && <Loader2 size={16} className="animate-spin" />} Send feedback
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
